import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TopicDrawerEmpty = () => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">{t('No hay resultados para tu búsqueda')}</Text>
    </Styles.Container>
  )
}

export default TopicDrawerEmpty
